import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import { REFERRAL_GIFT_VARIANT, ReferralGiftVariant } from '../constants';
import ReferralHomeCardDesktop from './ReferralHomeCardDesktop';
import { PRODUCT_LAYOUT, VARIANT_CONFIG } from './referralHomeCardConfig';

type ReferralHomeCardProps = {
  onClick: () => void;
  variant?: ReferralGiftVariant;
  flush?: boolean;
};

type CardProps = {
  $flush?: boolean;
};

const Card = styled.div<CardProps>`
  position: relative;
  width: 100%;
  max-width: ${({ $flush }) =>
    $flush ? '100%' : Spacings.APP_CONTAINER_WIDTH};
  margin: ${({ $flush }) =>
    $flush ? `${Spacings.SPACING_6B} 0 0` : `${Spacings.SPACING_10B} auto`};
  border-radius: ${Spacings.SPACING_3B};
  overflow: hidden;
  box-shadow: 0 ${Spacings.SPACING_3B} ${Spacings.SPACING_6B}
    var(--color-shadow);
  ${mediaQuery.uptoTablet} {
    margin-left: ${({ $flush }) => ($flush ? 0 : Spacings.SPACING_4B)};
    margin-right: ${({ $flush }) => ($flush ? 0 : Spacings.SPACING_4B)};
  }
`;

const ReferralHomeCard = ({
  onClick,
  variant = REFERRAL_GIFT_VARIANT.HUNTER,
  flush = false
}: ReferralHomeCardProps) => {
  const config = VARIANT_CONFIG[variant];
  const productLayout = PRODUCT_LAYOUT[variant];

  return (
    <Card $flush={flush}>
      <ReferralHomeCardDesktop
        onClick={onClick}
        variant={variant}
        config={config}
        productLayout={productLayout}
      />
    </Card>
  );
};

export default ReferralHomeCard;
